import PropTypes from "prop-types";
import styles from "./SnackBar.module.scss";
import config from "../../../config/index";

const SnackBar = props => {
  const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;
  return (
    <div
      className={props.isVisible ? `${styles.snackBar} ${props.className}` : ""}
    >
      <div className={styles.snackBar__msgContainer}>
        <label className={`${styles.snackBar__label} ${props.labelStyling}`}>{props.message}</label>
        <img
          className={styles.snackBar__closeImage}
          onClick={props.closeSnackBar}
          src={`${imagePrefix}/assets/images/error-copy.svg`}
          alt="placeholder"
        />
      </div>
    </div>
  );
};

SnackBar.propTypes = {
  message: PropTypes.string,
  style: PropTypes.object,
  closeSnackBar: PropTypes.func,
  isVisible: PropTypes.bool,
  className: PropTypes.string
};

export default SnackBar;
